package de.katoonerie.content

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import de.katoonerie.components.Container
import de.katoonerie.components.Gradient
import de.katoonerie.components.Prose
import de.katoonerie.components.UTurnUp
import de.katoonerie.contentful.Content
import de.katoonerie.contentful.Page
import de.katoonerie.contentful.Tile
import de.katoonerie.contentful.Tile.Gimmick.Position.bottomCenter
import de.katoonerie.contentful.Tile.Gimmick.Position.bottomLeft
import de.katoonerie.contentful.Tile.Gimmick.Position.bottomRight
import de.katoonerie.contentful.Tile.Gimmick.Position.leftBottom
import de.katoonerie.contentful.Tile.Gimmick.Position.leftCenter
import de.katoonerie.contentful.Tile.Gimmick.Position.leftTop
import de.katoonerie.contentful.Tile.Gimmick.Position.rightBottom
import de.katoonerie.contentful.Tile.Gimmick.Position.rightCenter
import de.katoonerie.contentful.Tile.Gimmick.Position.rightTop
import de.katoonerie.contentful.Tile.Gimmick.Position.topCenter
import de.katoonerie.contentful.Tile.Gimmick.Position.topLeft
import de.katoonerie.contentful.Tile.Gimmick.Position.topRight
import de.katoonerie.contentful.Tile.Gimmick.Position.unknown
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.w3c.dom.Element
import org.w3c.dom.HTMLDivElement

@Composable
fun Page.TilesPage() {
    LaunchedEffect("tilesPage-$path-${document.location?.hash ?: "top"}") {
        val hash = document.location?.hash
        when (hash.isNullOrBlank()) {
            true -> window.scrollTo(0.0, 0.0)
            else -> {
                val element = document.getElementById(hash.substring(1))
                if (element is Element) {
                    element.scrollIntoView()
                } else {
                    console.error("element with id ${hash.substring(1)} not loaded")
                }
            }
        }
    }
    Gradient {
        Container {
            NavigationBar()
            Tiles()
        }
        Button(attrs = {
            classes("w-8", "h-8", "md:fixed", "md:left-0", "md:bottom-0", "m-4")
            onClick {
                window.scrollTo(0.0, 0.0)
            }
            title("zurück")
        }) {
            UTurnUp()
        }
    }
}

@Composable
fun Page.NavigationBar() {
    navigationBar?.let {
        Div(attrs = { classes("py-4") }) {
            it.NavigationBar()
        }
    }
}

@Composable
fun Page.Tiles() {
    Div {
        tiles.forEach { tile ->
            tile.render()
        }
    }
}

@Composable
private fun Tile.render() {
    Div(attrs = {
        id(hash)
        classes("mx-auto", "flex", "flex-row", "flex-wrap", "p-4", "mb-8")
        if (layout == Tile.Layout.mediaLeftOfContent) {
            classes("md:flex-row-reverse")
        }
        style {
            backgroundColor(backgroundColor)
        }
    }) {
        if (layout != Tile.Layout.mediaWithoutContent) {
            Content()
        }

        val attrs: AttrsScope<HTMLDivElement>.() -> Unit = {
            if (layout != Tile.Layout.mediaWithoutContent) {
                classes("md:w-1/2")
            }
            classes("p-6", "w-full")
            classes("grid", "grid-cols-1", "lg:grid-cols-2", "gap-4", "content-start")
        }

        when (media) {
            is Content.Media.Gallery ->
                media.render(attrs = attrs)

            is Content.Media.YouTube ->
                media.render(attrs = attrs)

            is Content.Media.Actions ->
                media.render(attrs = attrs)
        }
    }
}

@Composable
private fun Tile.Content() {
    Div(attrs = {
        classes("w-full", "md:w-1/2", "p-4", "relative")
        ContentAttrs(body)
    }) {
        Prose(attrs = {
            classes("mx-auto", "prose-lg")
            style { body.color?.let { color(it) } }
        }) {
            body.document.Content()
        }

        gimmicks.forEach { gimmick ->
            gimmick.render()
        }
    }
}

@Composable
private fun Tile.Gimmick.render() {
    Div(attrs = {
        classes("absolute", "flex", "z-10")
        when (position) {
            topLeft, topCenter, topRight ->
                classes("top-[-70px]", "left-0", "right-0", "h-[150px]")

            leftTop, leftCenter, leftBottom ->
                classes("left-[-100px]", "top-0", "bottom-0", "w-[150px]", "flex-col")

            bottomLeft, bottomCenter, bottomRight ->
                classes("bottom-[-70px]", "left-0", "right-0", "h-[150px]")

            rightTop, rightCenter, rightBottom ->
                classes("right-[-100px]", "top-0", "bottom-0", "w-[150px]", "flex-col")

            unknown -> {}
        }
        when (position) {
            topLeft, leftTop, bottomLeft, rightTop ->
                classes("justify-start")

            topCenter, leftCenter, bottomCenter, rightCenter ->
                classes("justify-center")

            topRight, leftBottom, bottomRight, rightBottom ->
                classes("justify-end")

            unknown -> {}
        }
    }) {
        Div {
            image.render()
        }
    }
}
